import React, { Component } from 'react'
import ValidationUtil from '../../common/utils/ValidationUtil'
import styled from 'styled-components'

const TextAreaWrapper = styled.textarea`
  background-color: #fff;
  border: 1px solid #ccc;
  display: block;
  padding: 4px 6px;
  margin-bottom: 10px;
  font-size: 13px;
  line-height: 20px;
  color: #555;
  border-radius: 4px;
  vertical-align: middle;
  min-width: 300px;
  textarea[disabled] {
    background: #f4f4f4 !important;
  }
`

class DefaultTextArea extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: props.value || '',
      hasValue: false,
      truncateCount: 280
    }
  }
  componentWillMount() {
    const { value } = this.props

    this.setState({ hasValue: value !== '' })
  }
  get valueCount() {
    const { value } = this.state

    return value.length
  }
  onKeyPress = e => {
    const { onKeyPress } = this.props

    if (e.which === 13) {
      e.preventDefault()
      e.target.blur()
    }
    if (onKeyPress) {
      onKeyPress()
    }
  };
  onChangeInputText = ({ target: { value }}) => {
    this.setState({
      value,
      hasValue: value !== ''
    })
  };
  onValidateInput = e => {
    const { validationType, errorMessage, onBlur } = this.props
    const { value } = this.state

    let valid
    if (validationType) {
      valid = ValidationUtil.validate(value, validationType)
    } else {
      valid = errorMessage !== '' ? value !== '' : true
    }
    onBlur(e, valid)
  };
  renderCountTruncate = () => {
    const { state:  { truncateCount }, valueCount } = this
    const countIsZero = valueCount <= 0

    return (
      <small className="text-color-light-gray">
        {countIsZero ? truncateCount : `${valueCount}/${truncateCount}`} characters {countIsZero && 'max'}
      </small>
    )
  }
  render() {
    const {
      helpText,
      label,
      autocomplete: autoComplete,
      dataModel,
      dataModelId,
      format,
      name,
      placeholder,
      id,
      onKeyUp,
      onClick,
      error,
      errorMessage,
      truncate,
      disabled
    } = this.props
    const { value, truncateCount } = this.state

    let commonProps = {
      rows: "8",
      autoComplete,
      name,
      placeholder,
      id,
      value,
      onKeyUp,
      onClick,
      onChange: this.onChangeInputText,
      onBlur: this.onValidateInput,
      onKeyPress: this.onKeyPress,
      className: error ? 'error ' : '',
      disabled
    }

    if (truncate) {
      commonProps['maxLength'] = String(truncateCount)
    }

    return (
      <div className={helpText ? 'input-focus-message' : null}>
        {label && (
          <label
            htmlFor={id}
            dangerouslySetInnerHTML={{ __html: label }}
          />
        )}
        <TextAreaWrapper 
          data-model={dataModel}
          data-model-id={dataModelId}
          data-format={format}
          {...commonProps}
        />
        {truncate && this.renderCountTruncate()}
        <div
          className={error ? 'field_with_errors show-me' : 'focus-message text-color-light-gray'}
        >
          {error ? (
            <span className="help-block">
              {errorMessage}
            </span>
          ) :
            helpText
          }
        </div>
      </div>
    )
  }
}

export default DefaultTextArea
